import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import { SERVER_URL, BUILD_PLATFORM, PLATFORM_PWA, PLATFORM_ANDROID, PLATFORM_IOS } from '../constants';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import ListItemIcon from "@mui/material/ListItemIcon";
// import { downloadCsv, downloadCsvAndroid } from '../helpers/Helpers';
import { downloadCsv } from '../helpers/Helpers';
import QuickModal from './QuickModal';
import { formatDate } from '../helpers/Helpers';
import dayjs from 'dayjs';
import VerticalHamburgerMenu from './VerticalHamburgerMenu';
import { formatTime } from '../helpers/Helpers';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import Box from '@mui/material/Box';
import TimeSlotListNotesEditor from './TimeSlotListNotesEditor';
import { appointmentStatusToString } from '../helpers/Helpers';
import {appointmentStatusToIcon, appointmentStatusAvatarStyle} from '../helpers/Helpers';
import OfficeTodaysFixedScheduleStatusChange from './OfficeTodaysFixedScheduleStatusChange';
import OfficeTodaysFixedScheduleTimeChange from './OfficeTodaysFixedScheduleTimeChange';
import OfficeTodaysFixedScheduleAddName from './OfficeTodaysFixedScheduleAddName';
  
function OfficeTodaysFixedScheduleTimeSlotList (props) {

    useEffect(() => {
        props.fetchTimeSlotList();
    }, []);

    const [message, setMessage] = useState("fetching data...");

    const [timeSlots, setTimeSlots] = useState([]);

    const [statusChangeData, setStatusChangeData] = useState({});

    const [timeChangeData, setTimeChangeData] = useState({});

    const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);

    const [openTimeChangeModal, setOpenTimeChangeModal] = useState(false);

    const [openAddCustomerModal, setOpenCustomerModal] = useState(false);

    const handleDownloadCsv = () => {
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/list-timeslots/' + props.scheduleId, {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(data => {
            // console.log("fetchTimeSlotList data.data", data.data);
            var array = [];
            var header = {time: 'Time', name: 'Name', status: 'Status'};
            array.push(header);
            for (var item of data.data) 
            {
                var object = {};
                object.time = formatTime(item.time);
                object.name = item.name;
                object.status = appointmentStatusToString(item.appointment_status);
                array.push(object);
            }
            var csvFilename = props.officeName + " Timeslots " + props.rawDate;
            if (BUILD_PLATFORM === PLATFORM_PWA)
            {
                downloadCsv({data: array, fileName: csvFilename});
            }
            // if (BUILD_PLATFORM === PLATFORM_ANDROID)
            // {
            //     downloadCsvAndroid({data: csvData, fileName: csvFilename});
            //     setQuickModalMessage( "CSV file downloaded to your Documents folder: [" + csvFilename + ".csv]");
            //     setQuickModalOpen(true);
            // }
            if (data.data.length < 1) setMessage("No timeslots found");
        })
        .catch(err => console.error(err));
    }

    const handleDeleteTimeSlot = (params) => {
        deleteTimeSlot(params.timeSlotId);
    }

    const handleStatusChange = (params) => {
        // console.log("handleStatusChange", params);
        setStatusChangeData({
            office_id: params.officeId,
            id: params.appointmentId,
            name: params.customerName,
            status: params.status
        });
        setOpenStatusChangeModal(true);
    }

    const handleTimeChange = (params) => {
        // console.log("handleTimeChange", params);
        setTimeChangeData({
            office_id: params.officeId,
            id: params.appointmentId,
            name: params.customerName,
            status: params.status,
            time: params.time,
            time_slot_id: params.timeSlotId,
        });
        setOpenTimeChangeModal(true);
    }

    const [selectedTimeSlot, setSelectedTimeSlot] = useState({});

    const handleNotes = (params) => {
        setSelectedTimeSlot(params);
        setOpenNotesEditor(true);
    }

    const [insertCustomerData, setInsertCustomerData] = useState({});

    const handleInsertCustomer = (params) => {
        // console.log("handleAddCustomer ", params);
        setInsertCustomerData({
            time_slot_id: params.timeSlotId,
            office_id: params.officeId,
            time: params.time,
        });
        setOpenCustomerModal(true);
    }

    const [timeSlotVerticalMenuOptions, setTimeSlotVerticalMenuOptions] = useState([
        {
            id: 1,
            name: "Notes",
            callback: handleNotes,
        },
        {
            id: 2,
            name: "Change Status",
            callback: handleStatusChange,
        },
        {
            id: 3,
            name: "Change Time",
            callback: handleTimeChange,
            confirmMessage: "Are you sure you want to change the appointment time? This may cause confusion or dissatisfaction on the part of the customer."
        },
        {
            id: 4,
            name: "Delete Timeslot",
            callback: handleDeleteTimeSlot,
            confirmMessage: 'Are you sure you want to delete this timeslot?'
        },
        
    ]);

    const [reducedTimeSlotVerticalMenuOptions, setReducedTimeSlotVerticalMenuOptions] = useState([
        {
            id: 1,
            name: "Insert Client/Customer",
            callback: handleInsertCustomer,
        },
        {
            id: 2,
            name: "Delete Timeslot",
            callback: handleDeleteTimeSlot,
            confirmMessage: 'Are you sure you want to delete this timeslot?'
        }
    ]);

    const [deleModalOpen, setDeleteModalOpen] = useState(false);

    const [quickModalOpen, setQuickModalOpen] = useState(false);

    const [quickModalMessage, setQuickModalMessage] = useState("");

    const [openNotesEditor, setOpenNotesEditor] = useState(false);

    const deleteTimeSlot = (id) => {
            const token = sessionStorage.getItem("token");
            fetch(SERVER_URL + 'api/mod/delete-timeslot',
            {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization' : 'Bearer ' + token
                },
                body: JSON.stringify({
                    "id": id
                })
            })
            .then(response => response.json())
            .then(data => {
                if (data.status == 1) {
                    props.fetchTimeSlotList();
                } else {
                    
                }
            })
            .catch((err) => {
                console.error(err);
            });
        }

    return(
        <React.Fragment>
            <QuickModal 
                quickModalOpen={quickModalOpen}
                quickModalMessage={quickModalMessage}
                setQuickModalOpen={setQuickModalOpen} 
            />
            <List>
                {props.timeSlots.map(timeSlot => (
                    <ListItem key={timeSlot.id} alignItems="center">
                        <ListItemAvatar>
                            {timeSlot.appointment_status ? 
                            <Avatar sx={appointmentStatusAvatarStyle(timeSlot.appointment_status)}>
                                {appointmentStatusToIcon(timeSlot.appointment_status)}
                            </Avatar>
                            :
                            <Avatar>
                                <AccessAlarmIcon />
                            </Avatar>
                            }
                    </ListItemAvatar>
                        <ListItemText
                            sx={{ textAlign: 'center' }}
                            primary={formatTime(timeSlot.time)}
                            secondary={
                                <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: 'pre-line' }}>
                                    {timeSlot.user_id && timeSlot.name ? <strong>{timeSlot.name}</strong> : null}
                                    {timeSlot.user_id ? <br /> : null}
                                    {timeSlot.user_id ? appointmentStatusToString(timeSlot.appointment_status) : null}
                                </Typography>
                            }
                        />
                        <ListItemIcon>
                            <Box sx={{ ml: 2, display: 'flex', alignItems: 'right' }}>
                                <VerticalHamburgerMenu 
                                    params={{
                                        timeSlotId: timeSlot.id, 
                                        appointmentId: timeSlot.appointment_id,
                                        customerId: timeSlot.user_id,
                                        status: timeSlot.appointment_status,
                                        customerName: timeSlot.name,
                                        officeId: props.officeId,
                                        time: timeSlot.time
                                    }} 
                                    options={ timeSlot.appointment_id ? timeSlotVerticalMenuOptions : reducedTimeSlotVerticalMenuOptions} 
                                />
                            </Box>
                        </ListItemIcon>
                    </ListItem>
                ))} 
            </List>
            {props.timeSlots.length < 1 ? <Typography sx={{ textAlign: 'center' }} variant="body2" component="div">{props.message }</Typography> : null}
            {statusChangeData.id ? 
            <OfficeTodaysFixedScheduleStatusChange 
                customerAppointment={statusChangeData} 
                openStatusChangeModal={openStatusChangeModal} 
                setOpenStatusChangeModal={setOpenStatusChangeModal} 
                fetchTimeSlotList={props.fetchTimeSlotList}
            /> : null}
            {timeChangeData.id ? 
            <OfficeTodaysFixedScheduleTimeChange 
                customerAppointment={timeChangeData} 
                openTimeChangeModal={openTimeChangeModal} 
                setOpenTimeChangeModal={setOpenTimeChangeModal} 
                fetchTimeSlotList={props.fetchTimeSlotList}
            /> : null}
            {selectedTimeSlot.appointmentId ? 
            <TimeSlotListNotesEditor 
                showIcon={false}
                openNotesEditor={openNotesEditor}
                setOpenNotesEditor={setOpenNotesEditor}
                status={selectedTimeSlot.status} 
                date={props.rawDate} 
                officeId={props.officeId} 
                appointmentId={selectedTimeSlot.appointmentId} 
                customerId={selectedTimeSlot.customerId} 
                customerName={selectedTimeSlot.customerName} 
            />
            :null }
            {insertCustomerData.time_slot_id ? 
            <OfficeTodaysFixedScheduleAddName 
                openAddCustomerModal={openAddCustomerModal}
                setOpenCustomerModal={setOpenCustomerModal}
                officeId={props.officeId} 
                timeSlotId={insertCustomerData.time_slot_id} 
                time={insertCustomerData.time}
                fetchTimeSlotList={props.fetchTimeSlotList}
            />
            :null }
        </React.Fragment>
    );
}

export default OfficeTodaysFixedScheduleTimeSlotList;